// extracted by mini-css-extract-plugin
export var standaloneTable = "_hq-0";
export var standaloneTableWithBodyFill = "_hq-1";
export var withExtraHeader = "_hq-2";